<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="historico">
      {{'Detalhes do ' | translate}} {{acompanhamento.isCompromisso == 0 ? ('Acompanhamento' | translate ) :
      ('Compromisso' | translate )}}
    </ion-title>

    <ion-title *ngIf="!historico">
      {{'Gerenciar ' | translate}} {{acompanhamento.isCompromisso == 0 ? ('Acompanhamento' | translate ) :
      ('Compromisso' | translate )}}
    </ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-card class="card-full" *ngIf="acompanhamento.isCompromisso == 1">
    <ion-grid class="gradient-extendido-div">
      <ion-row class="ion-align-items-center ion-padding-bottom">
        <ion-col size="1">
          <i [ngStyle]="{'color': getFontColor(acompanhamento)}" class="{{getIcon(acompanhamento)}}"> </i>
        </ion-col>

        <ion-col size="10">
          <ion-label [ngStyle]="{'color': getFontColor(acompanhamento)}">{{acompanhamento.acao}} </ion-label>
        </ion-col>

        <ion-col size="1">
          <i
            class="fa-light fa-pen icon-edit"
            *ngIf="acompanhamento.tipo == 1 && isResponsavel && disabledCompromisso"
            (click)="editAcompanhamento(acompanhamento);"
          ></i>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-label>
            <p class="date-info">{{'Informações do compromisso' | translate}}</p>

            <p class="date-pipe">{{acompanhamento.datahora | dateFormat:"mediaHora"}}</p>
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row class="row-m border-bottom" *ngIf="acompanhamento.titulo">
        <ion-col>
          <ion-list>
            <ion-label>
              <p class="titulo-min">{{'TÍTULO' | translate}}</p>
              <p class="date">{{acompanhamento.titulo}}</p>
            </ion-label>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row class="row-m">
        <ion-col>
          <ion-list>
            <ion-label>
              <p class="titulo-min">{{'DETALHES' | translate}}</p>
              <p #descricao class="descricao" [ngClass]="{ 'truncated': !mostrarTexto }">
                {{acompanhamento.descricao}}
              </p>
              <span *ngIf="isOverflowing" class="ler-mais" (click)="lerMais()">
                {{ (mostrarTexto ? 'Ler Menos' : 'Ler Mais') | translate }}
              </span>
            </ion-label>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>

  <ion-card class="card-full" *ngIf="acompanhamento.isCompromisso == 0">
    <ion-grid class="gradient-extendido-div">
      <ion-row class="ion-padding-bottom">
        <ion-col size="10">
          <ion-label class="blue">{{'Acompanhamento' | translate}}</ion-label>
        </ion-col>
        <ion-col size="2" class="ion-text-end">
          <i
            class="fa-light fa-pen icon-edit"
            style="font-size: 20px !important"
            *ngIf="acompanhamento.tipo == 1 && isResponsavel && (disabledAcompanhamento || disabledCompromisso)"
            (click)="editAcompanhamento(acompanhamento);"
          ></i>
        </ion-col>
      </ion-row>

      <ion-row class="ion-align-items-center border-bottom ion-padding-bottom">
        <ion-col size="1">
          <i
            [ngStyle]="{'color': getFontColor(acompanhamento)}"
            class="{{getIcon(acompanhamento)}} icone-acompanhamento"
          ></i>
        </ion-col>

        <ion-col class="alinhamento-colum" size="11">
          <ion-row>
            <ion-col size="12" class="ion-no-padding">
              <ion-label [ngStyle]="{'color': getFontColor(acompanhamento)}"> {{acompanhamento.acao}} </ion-label>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="6" class="ion-no-padding">
              <span class="date">{{acompanhamento.categoria}}</span>
            </ion-col>
            <ion-col size="6" class="ion-no-padding ion-text-end">
              <span
                style="font-size: 11px"
                [ngClass]="{'green': acompanhamento.tipo == '0', 'red': acompanhamento.tipo == '2', 'blue': acompanhamento.tipo == '1'}"
              >
                {{acompanhamento.status | translate}}
              </span>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="12">
          <ion-label>
            <p class="text-uper">
              <span>{{'Informações do agendamento' | translate}}</span>
            </p>
            <p class="date-pipe">
              <span> {{acompanhamento.datahora | dateFormat:"mediaHora"}} </span>
            </p>
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="acompanhamento.titulo">
        <ion-col>
          <ion-list>
            <ion-label>
              <p class="text-uper">{{'TÍTULO' | translate}}</p>
              <p class="date">{{acompanhamento.titulo}}</p>
            </ion-label>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="acompanhamento.descricao" class="ion-padding-bottom">
        <ion-col>
          <ion-list>
            <ion-label>
              <h3 class="text-uper">{{'DETALHES' | translate}}</h3>
              <h3 #descricao class="descricao" [ngClass]="{ 'truncated': !mostrarTexto }">
                {{acompanhamento.descricao}}
              </h3>
              <span *ngIf="isOverflowing" class="ler-mais" (click)="lerMais()">
                {{ (mostrarTexto ? 'Ler Menos' : 'Ler Mais') | translate }}
              </span>
            </ion-label>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top border-top">
        <ion-col class="ion-no-padding">
          <p class="text-uper">{{'Informações complementares' | translate}}</p>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-bottom">
        <ion-col size="4" class="ion-no-padding">
          <ion-label class="d-flex ion-justify-content-start">
            <i class="fa-light fa-eye-slash icon-edit" style="color: #002fa7"></i>
            <span class="date" style="color: #002fa7; margin-left: 8px">
              {{acompanhamento.restrito == '1' ? ('Restrito' | translate) : ('Público' | translate)}}
            </span>
          </ion-label>
        </ion-col>
        <ion-col size="4" class="ion-no-padding">
          <ion-label
            class="d-flex ion-justify-content-start"
            *ngIf="isAtrasado(acompanhamento.datahora) && acompanhamento.tipo == 1 && isResponsavel && acompanhamento.isCompromisso == 0"
          >
            <i class="fa-light fa-clock icon-edit red"></i>
            <span class="date red" style="margin-left: 8px"> {{'Atrasado' | translate}} </span>
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="acompanhamento.tipo == 1 && isResponsavel && acompanhamento.isCompromisso == 0 && userProvider.hasConfig(213)"
        style="margin: 25px 0"
      >
        <ion-col size="6">
          <ion-button expand="block" class="btn-danger btn-custom" (click)="finalizar(acompanhamento)">
            {{'Finalizar' | translate}}
          </ion-button>
        </ion-col>

        <ion-col size="6">
          <ion-button expand="block" class="btn-default btn-custom" (click)="reagendar(acompanhamento)">
            {{'Reagendar' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row class="ion-align-items-center">
        <ion-col size="10">
          <h3 class="titulo">{{'Participantes' | translate}}</h3>
        </ion-col>

        <ion-col
          class="ion-text-end"
          size="2"
          *ngIf="acompanhamento.tipo == 1 && isResponsavel && userProvider.hasConfig(211)"
        >
          <i class="fa-light fa-pen icon-edit" (click)="editParticipantes(acompanhamento.participantes);"></i>
        </ion-col>
      </ion-row>

      <ion-row *ngFor="let part of acompanhamento.participantes">
        <ion-col size="11">
          <ion-item lines="none" class="avatar-square-contact">
            <ion-avatar slot="start">
              <img [src]="part.foto | image:' '" />
            </ion-avatar>
            <ion-label>
              <h3 class="date-info">{{part.nome}}</h3>

              <p class="date">{{'Participante' | translate}}</p>
            </ion-label>
          </ion-item>
        </ion-col>
        <ion-col size="1" class="d-flex">
          <ion-note *ngIf="isResponsavel" (click)="abrirDetalhes(part)">
            <i class="fa-solid fa-chevron-right icon-edit"></i>
          </ion-note>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="acompanhamento.responsaveis.length" class="ion-padding-top ion-align-items-center">
        <ion-col size="10">
          <h3 class="titulo">
            {{acompanhamento.isCompromisso == 0 ? ('Responsáveis' | translate) : ('Responsável' | translate)}}
          </h3>
        </ion-col>

        <ion-col
          size="2"
          *ngIf="acompanhamento.tipo == 1 && isResponsavel && acompanhamento.isCompromisso == 0 && userProvider.hasConfig(212)"
          class="ion-text-end"
        >
          <i class="fa-light fa-pen icon-edit" (click)="editResponsavel(acompanhamento.responsaveis);"></i>
        </ion-col>
      </ion-row>

      <div *ngIf="acompanhamento.responsaveis.length">
        <ion-row *ngFor="let resp of acompanhamento.responsaveis">
          <ion-col size="11">
            <ion-item lines="none" class="avatar-square-contact">
              <ion-avatar slot="start">
                <img [src]="resp.foto | image:' '" />
              </ion-avatar>
              <ion-label>
                <h3 class="date-info">{{resp.nome}}</h3>

                <p class="date">{{'Responsável' | translate}}</p>
              </ion-label>
            </ion-item>
          </ion-col>
          <ion-col size="1" class="d-flex">
            <ion-note *ngIf="isResponsavel" (click)="abrirDetalhes(resp)">
              <i class="fa-solid fa-chevron-right icon-edit"></i>
            </ion-note>
          </ion-col>
        </ion-row>
      </div>

      <ion-row *ngIf="!acompanhamento.responsaveis.length">
        <ion-col size="12">
          <ion-button expand="block" class="btn-default btn-custom" (click)="assumir(acompanhamento)">
            {{'Assumir Acompanhamento' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="showDescricao">
        <ion-col size="12" class="ion-no-padding">
          <ion-list>
            <h3 class="titulo">{{'Anotações' | translate}}</h3>
          </ion-list>
        </ion-col>

        <ion-col size="12" class="ion-no-padding">
          <ion-item lines="none">
            <ion-label>
              <p class="date-info">{{acompanhamento.descricao}}</p>

              <p *ngIf="acompanhamento.restrito == '0'" class="date-info">
                {{'Conteúdo disponível somente para responsáveis' | translate}}
              </p>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ion-content>

<ion-footer *ngIf="userProvider.hasConfig(217) && acompanhamento.isCompromisso == 0 && isResponsavel">
  <ion-row>
    <ion-col size="12">
      <ion-button expand="block" class="btn-default" (click)="encaminhar(acompanhamento)">
        {{'Encaminhar' | translate}}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
